import React from 'react';
import { fieldHelper } from '@builttocreate/engine-utils';

import FieldDisplayTypes from '../../../constants/FieldDisplayTypes';
import FieldTargetDisplayTypes from '../../../constants/FieldTargetDisplayTypes';
import SelectionField from './SelectionField';
import TextSelectionField from './TextSelectionField';

const { handleMultiSelectOptionToggle, getMultiSelectFieldValue } = fieldHelper;

function MultiSelectSelectionField({

  fieldId,
  fieldIdentifier,
  fieldPositionId,
  displayType,
  multi,
  value,
  options,
  disabled,
  invertBooleanCondition,

  targetValue,
  targetValueDisplayType,
  customTrueTargetDisplayValue,
  customFalseTargetDisplayValue,

  //SDK Styles
  primaryColor,

  //Field style
  fontSize,
  fontColor,
  fontStyle,
  fontWeight,
  textAlign,
  textTransform,
  textDecoration,
  textOverflow,
  borderColor,
  borderRadius,
  borderWidth,
  backgroundColor,
  padding,
  margin,

  //Action handlers
  onChange,
  onFocus

}) {
  const selectedOptions = getMultiSelectFieldValue(value);

  let selected = selectedOptions.indexOf(targetValue) !== -1;
  selected = invertBooleanCondition ? !selected : selected;

  const handleChange = () => {

    const nextSelections = handleMultiSelectOptionToggle(multi, selectedOptions, targetValue);

    if (onChange && targetValue) onChange(fieldId, fieldIdentifier, fieldPositionId, nextSelections);

  };

  const handleFocus = () => {

    if (onFocus) onFocus(fieldId, fieldIdentifier, fieldPositionId, {});

  };

  const fieldProps = {
    id: fieldPositionId,
    value: selected,
    disabled,
    displayType,
    onChange: handleChange,
    onFocus: handleFocus,

    primaryColor,
    fontSize,
    fontColor,
    fontStyle,
    fontWeight,
    textAlign,
    textTransform,
    textDecoration,
    textOverflow,
    borderColor,
    borderRadius,
    borderWidth,
    backgroundColor,
    padding,
    margin,
  };

  if (displayType === FieldDisplayTypes.text) {
    const targetOption = targetValue && options ? options.find((option) => option._id === targetValue) : {};
    const trueDisplayValue = targetValueDisplayType === FieldTargetDisplayTypes.custom ? customTrueTargetDisplayValue : targetOption.value;
    const falseDisplayValue = targetValueDisplayType === FieldTargetDisplayTypes.custom ? customFalseTargetDisplayValue : '';

    return (
      <TextSelectionField
        {...fieldProps}
        value={selected}
        trueDisplayValue={trueDisplayValue}
        falseDisplayValue={falseDisplayValue}
      />
    );

  } else {
    return (
      <SelectionField {...fieldProps} />
    );
  }

}

export default React.memo(MultiSelectSelectionField);
